import { useCompanyScores } from '@upright/ui/views/model-entity-views/company-view/use-company-scores';
import { pickDefaultModelResult } from '../../../../../common/model/data-point-pickers';
import { ModelResultWithScores } from '../../../../../common/model/output/scores/model-entity-data/types';

export function useDefaultCompanyResult(companyId: string): ModelResultWithScores | undefined {
  const companyScores = useCompanyScores(companyId).data;

  if (!companyScores || companyScores.id !== companyId) {
    return undefined;
  }
  return pickDefaultModelResult(companyScores.modelResults);
}

export function useDefaultCompanyResultAndLoadingStatus(companyId: string) {
  const companyScoresQuery = useCompanyScores(companyId);
  const companyScores = companyScoresQuery.data;

  const currentCompanyIdMatchesScoreId = companyScores?.id === companyId;

  if (!companyScores || !currentCompanyIdMatchesScoreId) {
    return {
      result: undefined,
      ...companyScores,
      error: companyScoresQuery.error,
    };
  } else {
    return {
      result: pickDefaultModelResult(companyScores.modelResults),
      ...companyScores,
      error: companyScoresQuery.error,
    };
  }
}
